import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SafeUrl} from '@angular/platform-browser';
import {SafePipe} from '../../pipes/safe.pipe';
import {SafeStringType} from 'src/app/modules/clm/types/safe-string-type.enum';

@Component({
  selector: 'app-generic-iframe-dialog',
  templateUrl: './generic-iframe-dialog.component.html',
  styleUrls: ['./generic-iframe-dialog.component.scss'],
  providers: [SafePipe]
})
export class GenericIframeDialogComponent implements OnInit {
  safeUrl: SafeUrl;

  constructor(
    private safePipe: SafePipe,
    public dialogRef: MatDialogRef<GenericIframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    this.safeUrl = this.safePipe.transform(this.data.src, SafeStringType.ResourceUrl);
  }

  onClickOkay() {
    this.dialogRef.close();
  }
}
